import { Controller } from 'stimulus';

export default class SiteSubsubmenuController extends Controller {
  static targets = ['link', 'menuWrapper', 'container'];

  activeIndex = -1;

  connect() {
    this.linkTargets.forEach((link) => {
      link.addEventListener('click', this.onLinkClick);
    });
  }

  disconnect() {
    this.linkTargets.forEach((link) => {
      link.removeEventListener('click', this.onLinkClick);
    });
  }

  hideActiveMenu(instantly = true) {
    if (instantly) {
      while (this.containerTarget.firstChild) {
        this.containerTarget.removeChild(this.containerTarget.firstChild);
      }
    }

    if (this.activeIndex === -1) {
      return;
    }

    this.linkTargets[this.activeIndex].classList.remove('active');
    this.containerTarget.classList.remove('active');
    this.activeIndex = -1;
  }

  getMenuContent(element) {
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < element.children.length; i++) {
      fragment.appendChild(element.children[i].cloneNode(true));
    }

    return fragment;
  }

  showMenu(index) {
    if (index < 0 || index >= this.menuWrapperTargets.length) {
      return;
    }

    const menu = this.getMenuContent(this.menuWrapperTargets[index]);
    this.linkTargets[index].classList.add('active');
    this.containerTarget.appendChild(menu);
    /* eslint-disable no-unused-expressions */
    this.containerTarget.offsetWidth;
    this.containerTarget.classList.add('active');
    this.activeIndex = index;
  }

  onLinkClick = (event) => {
    const currentIndex = this.activeIndex;
    const index = this.linkTargets.indexOf(event.target);
    const sameLink = currentIndex === index;
    this.hideActiveMenu(!sameLink);
    if (!sameLink) {
      this.showMenu(index);
    }
  };
}
